import { useEffect, useState } from 'react';

import { UnsupportedBrowser } from '@rikstv/play-player/src/components/UnsupportedBrowser/UnsupportedBrowser';
import { browserKeySystem, isEncryptedMediaExtensionActivatedForKeySystem } from '@rikstv/play-player/src/utils/drm';

const keySystem = browserKeySystem();

export const useIsUnsupported = () => {
  const [isUnSupportedBrowser, setIsUnSupportedBrowser] = useState<boolean>();

  useEffect(() => {
    isEncryptedMediaExtensionActivatedForKeySystem(keySystem).then(isSupported =>
      setIsUnSupportedBrowser(!isSupported)
    );
  }, []);

  if (isUnSupportedBrowser) {
    return UnsupportedBrowser;
  }

  return null;
};
